<template>

    <div class="">

        <app-head :title="Advent">
        </app-head>

        <article class="page">

            <div class="mb-4 d-flex align-items-center py-5" style="min-height: 80vh; background: left 70% url(/img/specials/advent2022/Hintergrund.jpg) no-repeat; background-size: cover; background-attachment: fixed;">
                <div class="container narrow-container">
                    <div class="text-center text-dark">
                        <h1 class="display-2">
                            <i>
                                Liebe Mitglieder,
                            </i>
                        </h1>
                        <p class="h3 lh-lg">
                            wir wünschen Ihnen eine schöne, besinnliche Adventszeit.<br>
                                Versüßen möchten wir Ihnen diese besondere Zeit mit wechselnden Angeboten unserer Kooperationspartner.
                        </p>
                        <p class="fs-5 mt-5">
                            Weitere Einzelheiten finden Sie weiter unten
                        </p>
                        <div class="h1">
                            <i class="bi bi-arrow-down"></i>
                        </div>
                    </div>
                </div>
            </div>


            <div class="container py-5" style="">

                <div class="text-center">

                    <h2 class="display-6 mb-5 lh-base text-primary">
                        <i>
                            Zum 4. Advent haben sich Pluradent / Dental Bauer und Schütz Dental folgende Angebote für Sie einfallen lassen:
                        </i>
                    </h2>

                    <!--                    <div class="mt-5 p-5" style="background: url(/suppliers/picodent/picodent-berg.jpg) no-repeat; background-size: cover;">
                                            <div class="row">
                                                <div class="col-lg-8 text-light d-flex align-items-center">
                                                    <div>
                                                        <h3 class="h1 my-2">
                                                            Verlosung von 10 Gutscheinen im Wert von 50 €
                                                        </h3>
                                                        <p class="fs-5 my-2">
                                                            Zur Teilnahme am Gewinnspiel senden Sie uns bitte eine Mail an <a href="mailto:gewinnspiel@dentagen.de">gewinnspiel@dentagen.de</a>.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4">
                                                    <div class="row align-items-center">
                                                        <div class="col-md-5 mt-3">
                                                            <img src="/img/logos/picodent.png" alt="" class="img-fluid" style="min-width: 300px;" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>-->

                    <div class="mt-5 bg-dark p-5">
                        <div class="row flex-row-lg-reverse">
                            <div class="col-lg-6 text-light d-flex align-items-center">
                                <div>
                                    <h2 class="mb-4">Profitieren Sie den kompletten Februar 2023 von einer versandkostenfreien Lieferung Ihrer dental bauer Bestellung.</h2>
                                    <h3 class="fw-normal mb-4">Verwenden Sie dazu den Code: <b>dental bauer 2023</b> und starten Sie mit dieser Aktion entspannt in das neue Jahr.</h3>
                                    <p class="text-white-50">Die Aktion hat eine Gültigkeit vom 01.02.2023 bis 28.02.2023.</p>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <a href="/haendler/pluradent">
                                    <img src="/img/specials/advent2022/dentalbauer.png" alt="dentalbauer" class="img-fluid" />
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="mt-5 bg-dark p-5">
                        <div class="row">
                            <div class="col-lg-6 text-light d-flex align-items-center">
                                <div>
                                    <h2 class="mb-4">Aktion priti®perfect Basic Set<br> (Artikel-Nr.: ZT22110) </h2>
                                    <h3 class="fw-normal mb-4">
                                        Die perfekte Ergänzung für ein lebendiges Oberflächen-Finish
                                        293,25 € statt 345,00 € (15 % Rabatt)*
                                    </h3>
                                    <p class="small text-white-50 mb-4">*Preise zzgl. gesetzlicher MwSt. zzgl. Versandkosten</p>
                                    <p>
                                        <a href="/produkte/417423/pritiperfect-basic-set" class="btn btn-lg btn-outline-primary">Zum Produkt</a>        
                                    </p>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <a href="/produkte/417423/pritiperfect-basic-set">
                                    <img src="https://marktplatz.dentagen.de/storage/suppliers/633/6b/c0/sm-6bc02605d5729041bd07d7c14648d6c0.png" alt="viking" class="img-fluid" />
                                </a>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="mt-5 py-5 text-center">
                    <p>
                        Sofern wir (einen) Gutschein(e) verlosen, senden Sie uns bitte eine Mail an <a href="mailto:gewinnspiel@dentagen.de">gewinnspiel@dentagen.de</a>. 
                    </p>
                    <p class="">
                        So nehmen Sie unter Angabe des Kooperationspartners und Ihrer Mitgliedsnummer an der Verlosung teil. Mail-Zusendungen werden berücksichtigt, solange die Aktion online ist.
                    </p>
                    <p class="">
                        Der Rechtsweg ist ausgeschlossen. Irrtümer und Preisänderungen vorbehalten.
                    </p>
                </div>

            </div>

        </article>

    </div>

</template>

<script>

    export default {
        props: [
        ],
        data() {
            return {
            }
        },
        components: {
        },
        methods: {
        },
    }
</script>